export default "__VITE_ASSET__DnD415cH__"